import { ReactComponent as Cardio } from '1_shared/assets/pictures/stack/icons/cardio.svg';
import { ReactComponent as Kids } from '1_shared/assets/pictures/stack/icons/kids.svg';
import { ReactComponent as Loss } from '1_shared/assets/pictures/stack/icons/loss.svg';
import { ReactComponent as Money } from '1_shared/assets/pictures/stack/icons/money.svg';
import { ReactComponent as Romance } from '1_shared/assets/pictures/stack/icons/romance.svg';
import { ReactComponent as Shield } from '1_shared/assets/pictures/stack/icons/shield.svg';
import { ReactComponent as Smileys } from '1_shared/assets/pictures/stack/icons/smileys.svg';
import { ReactComponent as UserRefresh } from '1_shared/assets/pictures/stack/icons/user-refresh.svg';
import { IProblemsList } from '../interfaces/IProblem';

/*
 * Массив содержит в себе информацию, отображаемую на главной странице,
 * а так же при клике на один из этих элементов массива на главной странице,
 * в состояние заносится информация, которая далее будет применена для первого
 * шага в анкете
 */
export const problemList: IProblemsList[] = [
  {
    title: 'Отношения',
    icon: <Romance width={49} height={49} />,
    info: {
      topic: 'Отношения',
      // Cтрах общения, отсутствие отношений
      problems: ['fear-of-communication', 'absence-of_relations'],
    },
  },
  {
    title: 'Дети, подростки',
    icon: <Kids width={49} height={49} />,
    info: {
      topic: 'Отношения',
      // Отношение с детьми
      problems: ['relationship-trouble-with-children-with-teenagers'],
    },
  },
  {
    title: 'Самооценка',
    icon: <UserRefresh width={49} height={49} />,
    info: {
      topic: 'Самооценка, самоопределение',
      // Низкая самооценка
      problems: ['low-self-esteem'],
    },
  },
  {
    title: 'Насилие',
    icon: <Shield width={49} height={49} />,
    info: {
      topic: 'Жизненные события',
      // Насилие
      problems: ['violence'],
    },
  },
  {
    title: 'Утрата',
    icon: <Loss width={49} height={49} />,
    info: {
      topic: 'Жизненные события',
      // Утрата близкого
      problems: ['loss-of-loved-one'],
    },
  },
  {
    title: 'Финансы, карьера',
    icon: <Money width={49} height={49} />,
  },
  {
    title: 'Здоровье и психосоматика',
    icon: <Cardio width={49} height={49} />,
    info: {
      topic: 'Психосоматика',
      //  Тревога о здоровье
      problems: ['health-anxiety'],
    },
  },
  {
    title: 'Эмоциональное состояние',
    icon: <Smileys width={49} height={49} />,
    info: {
      topic: 'Эмоциональное состояние',
      // Перепады настроения
      problems: ['mood-swings'],
    },
  },
];
